import { render, staticRenderFns } from "./PreferencesIntro.vue?vue&type=template&id=42868dd0&scoped=true"
import script from "./PreferencesIntro.vue?vue&type=script&lang=js"
export * from "./PreferencesIntro.vue?vue&type=script&lang=js"
import style0 from "./PreferencesIntro.vue?vue&type=style&index=0&id=42868dd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42868dd0",
  null
  
)

export default component.exports